import { useEffect, useMemo, useState } from 'react';
import { frameColumnsForClaimsDocuments } from '../../../../Member/utils/common';
import ClaimsDocumentsTable from './ClaimsDocumentsTable';
import ClaimsDocumentsSkeleton from './skeleton/ClaimsDocumentsSkeleton';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { IconSVG } from '../../../img/uploadDocument/uploadDocumentSVG';
import { arrayBufferToBase64 } from 'src/Admin/utils/common';

const ClaimsDocuments = ({ getClaimNumber }) => {
  const [getClaimsDocumentList, setGetClaimsDocumentList] = useState([]);
  //FilteredList
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [pageSizeLocal, setPageSizeLocal] = useState(5);
  const [totalRecords, setTotalRecords] = useState([]);

  const [pageCount, setPageCount] = useState(1);
  const [dataFetching, setDataFetching] = useState(true);

  const downloadFile = async (reportName, byte, contentType) => {
    const actualData = arrayBufferToBase64(byte);
    const link = document.createElement('a');
    link.setAttribute('href', `data:${contentType};base64,` + actualData);
    link.setAttribute('download', reportName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = (docData) => async () => {
    try {
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getDocumentsDownload()}doclocation/${
          docData?.PermStorageLoc
        }/id/${docData?.DCN}`,
        { responseType: 'arraybuffer' },
      );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(docData?.OrigFileName, responseDetails?.data, contentType);
    } catch (err) {
      return;
    }
  };

  const documentDataList = async () => {
    setDataFetching(true);

    try {
      const responseDocument = await axiosInstance.get(
        APIEndpoints.getClaimsDocumentList() +
          getClaimNumber +
          '/viewimginportalflag/Y',
      );
      const documentListData =
        responseDocument?.data?.Response?.documentslistDTO;
      setGetClaimsDocumentList(documentListData);
      setTotalRecords(documentListData);
      console.log('documentListData', responseDocument, documentListData);
      setDataFetching(false);
    } catch (error) {
      if (error.toString().includes('404')) {
        console.log('error', error);
        setDataFetching(false);
      }
    }
  };

  const frameDataToDisplay = (docData) => {
    if (docData?.length > 0) {
      const records = [];
      const iterationCount = docData.length;
      for (let iIndex = 0; iIndex < iterationCount; iIndex++) {
        records.push({
          Title: docData[iIndex].Description,
          File: docData[iIndex].OrigFileName,
          SentDate: docData[iIndex].LastViewedOnDate,
          Download: (
            <span
              className="cursor-pointer d-flex justify-content-center"
              onClick={handleDownload(docData[iIndex])}
            >
              {' '}
              <IconSVG />
            </span>
          ),
        });
      }
      setFilteredRecords(records.slice(0, pageSizeLocal));
    } else {
      setFilteredRecords([]);
    }
  };

  useEffect(() => {
    if (getClaimsDocumentList?.length > 0) {
      frameDataToDisplay(getClaimsDocumentList);
    }
  }, [getClaimsDocumentList]);
  useEffect(() => {
    if (getClaimNumber) documentDataList();
  }, [getClaimNumber]);

  useEffect(() => {
    //setFilteredRecords(getClaimsDocumentList.slice(0, pageSizeLocal));
    frameDataToDisplay(getClaimsDocumentList);
  }, [pageSizeLocal]);

  useEffect(() => {
    setPageSizeLocal(pageCount * 5);
    console.log('pageCount===', pageCount);
  }, [pageCount]);

  console.log('documentListData_filteredRecords', filteredRecords);

  const columnNames = useMemo(() => {
    return frameColumnsForClaimsDocuments();
  }, [getClaimsDocumentList]);

  return (
    <div className="">
      {dataFetching ? (
        <ClaimsDocumentsSkeleton />
      ) : (
        <div className="claims-documents-details">
          <div className="title">Documents</div>
          <div className="claims-documents-table-grid">
            <ClaimsDocumentsTable
              columns={columnNames}
              data={filteredRecords}
              keyField={columnNames}
              setPageSizeLocal={setPageSizeLocal}
              pageSizeLocal={pageSizeLocal}
              setPageCount={setPageCount}
              pageCount={pageCount}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClaimsDocuments;
